import { useEffect, useState } from 'react';
import { navLinks } from '@/mocks/homeData';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleJump = () => setMenuOpen(false);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled || menuOpen ? 'bg-background-50/95 backdrop-blur border-b border-background-200' : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-8 h-16 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2 cursor-pointer">
          <span
            className={`w-9 h-9 rounded-lg flex items-center justify-center ${
              scrolled || menuOpen ? 'bg-primary-500 text-background-50' : 'bg-background-50/90 text-primary-700'
            }`}
          >
            <i className="ri-cup-line text-lg"></i>
          </span>
          <span className={`font-heading text-lg font-bold ${scrolled || menuOpen ? 'text-foreground-950' : 'text-background-50'}`}>
            茶杯狐影视
          </span>
        </a>

        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={`#${link.id}`}
              className={`px-3 py-2 rounded-md text-sm transition-colors cursor-pointer ${
                scrolled
                  ? 'text-foreground-700 hover:text-primary-700 hover:bg-background-100'
                  : 'text-background-50/90 hover:text-background-50 hover:bg-background-50/10'
              }`}
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <a
            href="#entrances"
            className="hidden sm:inline-flex items-center gap-1.5 rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
          >
            <i className="ri-compass-3-line"></i>
            查看入口
          </a>
          <button
            type="button"
            aria-label="展开导航菜单"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((v) => !v)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer ${
              scrolled || menuOpen ? 'text-foreground-900' : 'text-background-50'
            }`}
          >
            <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
          </button>
        </div>
      </nav>

      {menuOpen ? (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 py-3">
          <div className="flex flex-col">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                onClick={handleJump}
                className="py-2.5 text-sm text-foreground-700 cursor-pointer hover:text-primary-700"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#entrances"
              onClick={handleJump}
              className="mt-2 inline-flex items-center justify-center gap-1.5 rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 cursor-pointer"
            >
              <i className="ri-compass-3-line"></i>
              查看入口
            </a>
          </div>
        </div>
      ) : null}
    </header>
  );
}